import i18next from 'i18next';
import { ClinicsView } from 'infrastructure/enums';

export interface IClinicViewItem {
  id: ClinicsView;
  name: string;
}

export const clinicViewDataSource = (): IClinicViewItem[] => {
  return [
    {
      id: ClinicsView.Default,
      name: i18next.t('clinics.viewDefault'),
    },
    {
      id: ClinicsView.ParentToChild,
      name: i18next.t('clinics.parentToChild'),
    },
  ];
};
